export default __webpack_public_path__ + "static/media/foot4.78d35adf.jpg";